// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2k3gf","inner":"Footer_inner__1HyDq","nextIcon":"Footer_nextIcon__3yMgn","innerLeft":"Footer_innerLeft__184lA"};